/**
 * Created by lxhfight on 2018/4/8.
 * Email:
 * Description:
 *    匹配信息
 */
import { roleList, statusMap, ShipPayMethods, Shipopts, PURCHASE_FROM, WISH_TYPE, Shipways } from './constant'
import { phoneRegex, telRegex } from './regex'

const wishTopic = '聖誕'

const CONVENIENCE_STORE_PICKUP = {
  [Shipways.SHIPWAY_SEVEN_ELEVEN]: '7-11',
  [Shipways.SHIPWAY_HILIFE]: '萊爾富'
}

const getConvenienceStorePickupNotice = (deal, isMeet) => {
  if (isMeet || !deal) return ''
  const storeName = CONVENIENCE_STORE_PICKUP[deal.shipway]
  if (!storeName) return ''
  return `，禮物抵達${storeName}「只會在APP通知」，收到通知後帶證件告知手機末三碼即可領取，記得打開 GC贈物網的系統通知喔！`
}

export const transferRole = (val) => {
  let match = roleList.find(item => item.value === val)
  if (match) {
    return match.label
  }
  return ''
}

export const MapMsg = (msg) => {
  let text = ''
  switch (msg.text) {
    // 心願認領相關消息枚舉值
    case 'WISH_DONATE_GIVER': {
      // 愛閱書籍不需要祝福卡片，文案只寫寄書
      const isReading = !!(msg.deal && msg.deal.wish && msg.deal.wish.type === WISH_TYPE.READING)
      const wishName = isReading ? '愛閱書籍' : wishTopic + '心願'
      const receivedName = isReading ? '書籍' : '禮物'
      const prepareText = isReading
        ? '請您將書籍寄至以下資料：'
        : '請您將「禮物＋祝福卡片」一起寄至以下資料：'
      const closingText = isReading
        ? '請採簡易包裝，並於收件地址旁註明「書籍編號」及「您的暱稱」。謝謝您~'
        : '讓孩子收到期待的禮物以及一張專屬的鼓勵卡片。謝謝您~'
      text = `感謝您的愛心，已成功認養${msg.receiver}的${wishName}「${msg.name}」，我們將在收到${receivedName}的五天內留言通知您。
        ${prepareText}
        姓名：GC贈物網 幸福偏鄉小組 收
        電話：0927-702-966
        地址：115-03 臺北市南港區園區街3-2號9樓之1（903室）
        ${closingText}`
      break
    }
    case 'WISH_DONATE_GREETING_GIVER':
      text = `收到了${msg.receiver}小朋友的感謝卡片，趕快點擊查看吧`
      break
    // case 'WISH_DONATE_RECEIVER':
    //   text = ``
    //   break
    case 'WISH_DONATE_THANKS_GIVER':
      text = `您的心願認養「${msg.name}」已送達，收到了一份感謝，趕快點擊查看吧`
      break
    case 'GIFT_REQUEST_REQUESTING_GIVER':
      text = `${msg.receiver}向您索取「${msg.name}」`
      break
    case 'NEED_DONATE_INIT_GIVER':
      text = `您想將「${msg.allNeedItemNames || msg.name}」送給${msg.receiver}` + (!msg.directPurchase ? `，請等待${msg.receiver}確認收下` : '')
      break
    case 'NEED_DONATE_INIT_RECEIVER':
      text = `${msg.giver}想將「${msg.allNeedItemNames || msg.name}」送給您`
      break
    case 'NEED_DONATE_REMITTING_GIVER':
      text = `${msg.receiver}已確認收下您的「${msg.name}」${msg.passNeedItemNames && msg.passNeedItemNames.length ? '，婉拒了' + msg.passNeedItemNames : ''}${msg.deal && msg.deal.shipway === Shipways.SHIPWAY_HOMENG ? '，最終運費將由GC管理員私訊報價給寄收雙方，如付款方確認要寄送，將由物流士主動聯繫雙方寄收日期。' : ''}`
      break
    case 'NEED_DONATE_REMITTING_RECEIVER':
      text = `您已確認收下${msg.giver}的「${msg.name}」${msg.passNeedItemNames && msg.passNeedItemNames.length ? '，婉拒了' + msg.passNeedItemNames : ''}`
      break
    case 'NEED_DONATE_REMITTED_GIVER':
      text = `${msg.receiver}已經匯款給您的「${msg.name}」`
      break
    case 'NEED_DONATE_REMITTED_RECEIVER':
      text = `您已匯款給${msg.giver}的「${msg.name}」`
      break
    case 'NEED_DONATE_THANKS_GIVER':
      text = `您的禮物「${msg.name}」收到一則感謝`
      break
    case 'NEED_DONATE_THANKS_RECEIVER':
      text = ``
      break
    case 'NEED_DONATE_PASS_GIVER':
      text = `${msg.receiver}婉拒了「${msg.name}」`
      break
    case 'NEED_DONATE_PASS_RECEIVER':
      text = `您婉拒了「${msg.name}」`
      break
    case 'NEED_DONATE_QUANTITY_FULL_GIVER':
      text = `「${msg.name}」已經募滿了`
      break
    case 'NEED_DONATE_QUANTITY_FULL_RECEIVER':
      text = `「${msg.name}」已經募滿了`
      break
    case 'NEED_DONATE_PULL_OFF_GIVER':
      text = `${msg.receiver}的「${msg.name}」募集已結束`
      break
    case 'NEED_DONATE_PULL_OFF_RECEIVER':
      text = `${msg.receiver}的「${msg.name}」募集已結束`
      break
    case 'NEED_DONATE_CANCEL_GIVER':
      text = `您取消了「${msg.name}」的贈送`
      break
    case 'NEED_DONATE_CANCEL_RECEIVER':
      text = `${msg.giver}取消了「${msg.name}」的贈送`
      break
    case 'NEED_DONATE_RECEIVED_GIVER':
      text = `您已收到${msg.receiver}的匯款`
      break
    case 'NEED_DONATE_RECEIVED_RECEIVER':
      text = `${msg.giver}已收到您的匯款`
      break
    case 'NEED_DONATE_SENT_GIVER':
      text = `您已將「${msg.name}」${msg.isMeet ? '面交' : '寄出'}`
      break
    case 'NEED_DONATE_SENT_RECEIVER':
      text = `${msg.giver}已將「${msg.name}」${msg.isMeet ? '面交' : '寄出'}${getConvenienceStorePickupNotice(msg.deal, msg.isMeet)}`
      break
    case 'NEED_DONATE_FINISHED_GIVER':
      text = `「${msg.name}」已完成贈送`
      break
    case 'NEED_DONATE_FINISHED_RECEIVER':
      text = `「${msg.name}」已完成贈送`
      break
    case 'GIFT_REQUEST_REMITTING_GIVER':
      text = `您已確定要將「${msg.name}」送給${msg.receiver}\
      ${(msg.deal && msg.deal.shipopts === Shipopts.RECEIVER && msg.deal.pay_method === ShipPayMethods.OFFLINE) ? '，等待對方匯款' : ''}${msg.deal && msg.deal.shipway === Shipways.SHIPWAY_HOMENG ? '，GC管理員詢價後，7個工作天內私訊報價給雙方。付款方確認後，物流會主動聯絡搬運時間。' : ''}`
      break
    case 'GIFT_REQUEST_REMITTING_RECEIVER':
      text = `${msg.giver}已確定要將「${msg.name}」送給您\
      ${msg.deal && msg.deal.shipway === Shipways.SHIPWAY_HOMENG ? '，GC管理員詢價後，7個工作天內私訊報價給雙方。付款方確認後，物流會主動聯絡搬運時間。' : ((msg.deal && msg.deal.shipopts === Shipopts.RECEIVER && msg.deal.pay_method === ShipPayMethods.OFFLINE) ? '，請盡快匯運費' : '')}`
      break
    case 'GIFT_REQUEST_REMITTED_GIVER':
      text = `${msg.receiver}已匯款給您的「${msg.name}」`
      break
    case 'GIFT_REQUEST_REMITTED_RECEIVER':
      text = `您已匯款給${msg.giver}的「${msg.name}」`
      break
    case 'GIFT_REQUEST_THANKS_GIVER':
      text = `您的禮物「${msg.name}」收到一則感謝`
      break
    case 'GIFT_REQUEST_THANKS_RECEIVER':
      text = ``
      break
    case 'GIFT_REQUEST_PASS_GIVER':
      text = ``
      break
    case 'GIFT_REQUEST_PASS_RECEIVER':
      text = ``
      break
    case 'GIFT_REQUEST_CANCEL_GIVER':
      text = `您取消了「${msg.name}」的贈送`
      break
    case 'GIFT_REQUEST_CANCEL_RECEIVER':
      text = `${msg.giver}取消了「${msg.name}」的贈送`
      break
    case 'GIFT_REQUEST_RECEIVED_MONEY_GIVER':
      text = `您已收到${msg.receiver}對「${msg.name}」的匯款`
      break
    case 'GIFT_REQUEST_RECEIVED_MONEY_RECEIVER':
      text = `${msg.giver}已收到您對「${msg.name}」的匯款`
      break
    case 'GIFT_REQUEST_SENT_GIVER':
      text = `您已將「${msg.name}」${msg.isMeet ? '面交' : '寄出'}`
      break
    case 'GIFT_REQUEST_SENT_RECEIVER':
      text = `${msg.giver}已將「${msg.name}」${msg.isMeet ? '面交' : '寄出'}${getConvenienceStorePickupNotice(msg.deal, msg.isMeet)}`
      break
    case 'GIFT_REQUEST_FINISHED_GIVER':
      text = `「${msg.name}」已完成贈送`
      break
    case 'GIFT_REQUEST_FINISHED_RECEIVER':
      text = `「${msg.name}」已完成贈送`
      break
    case 'SYSTEM_CONTENT_USER_ROLE_PASS':
      text = `您已通過審核，會員身份成功變更為 ${transferRole(msg.user_category)}`
      break
    case 'SYSTEM_CONTENT_USER_ROLE_REJECT':
      text = `您的身分變更申請被暫時擱置，請補充資料後重新提交`
      break
    case 'SYSTEM_CONTENT_USER_ROLE_TIMEOUT':
      text = '您的關懷會員文件已過期，請重新提交最新的證明文件'
      break
    case 'SYSTEM_CONTENT_USER_IDENTITY_PASS':
      text = '恭喜～您已完成實名驗證！'
      break
    case 'SYSTEM_CONTENT_USER_IDENTITY_REJECT':
      text = '您的實名驗證資料有誤，請補充資料後重新提交唷！'
      break
    case 'WISH_DONATE_NOT_RECEIVED': {
      // 愛閱書籍不需要祝福卡片，提醒文案只寫寄書
      const isReading = !!(msg.deal && msg.deal.wish && msg.deal.wish.type === WISH_TYPE.READING)
      text = isReading
        ? `感謝您認養孩子的愛閱心願
      📚 今天是認養後的第 5 天，提醒您別忘了準備：
      📚 孩子的心願書籍
      孩子們都很期待能讀到這本書，也期待收到一份專屬於自己的閱讀禮物。
      請記得在認養後 10 天內寄出「書籍」。若第 10 天仍尚未寄出，我們將把這份心願重新開放，讓下一位愛心朋友接力完成。
      謝謝您，讓孩子的閱讀心願成真 ❤️`
        : `感謝您認養孩子的聖誕心願
      🎁 今天是認養後的第 5 天，提醒您別忘了準備：
      🎁 孩子的心願禮物
      💌 一張給孩子的親筆祝福卡片
      孩子們都很期待一年一度的聖誕心願，也期待收到一份專屬於自己的鼓勵。
      請記得在認養後 10 天內寄出「禮物＋祝福卡片」。若第 10 天仍尚未寄出，我們將把這份心願重新開放，讓下一位愛心朋友接力完成。
      謝謝您，讓孩子期待的聖誕心願成真 ❤️`
      break
    }
    case 'NEW_USER_INTERESTS':
      if (msg.business) {
        const { keyword, gift_id: giftId, need_id: needId, provision_id: provisionId, title } = msg.business
        let type = ''
        if (giftId) {
          type = '禮物'
        } else if (needId) {
          type = '需求'
        } else if (provisionId) {
          type = 'GC代贈'
        }
        text = `您訂閱的「${keyword}」有了新的${type}上傳「${title}」, 快去看下吧`
      }
      break
    case 'LOVE_BOX_RECEIVED':
      text = '您收到的物品是支持公益環保的優質企業所提供，現在是您回饋的時候了～要的不多，請點我上傳照片及感謝話語，讓贈送者有源源不絕的分享動力哦！'
      break
    case 'LOVE_BOX_THANKS_GIVER':
      text = `您的GC代贈「${msg.name}」收到一則感謝`
      break
    case 'GIFT_REQUEST_MERGE_NOTICE_GIVER':
      text = `您合併了送給${msg.receiver}的「${msg.name}」等禮物`
      break
    case 'GIFT_REQUEST_MERGE_APPLY_GIVER':
      text = `您收到來自${msg.receiver}的合併請求`
      break
    case 'GIFT_REQUEST_MERGE_REJECT_GIVER':
      text = `您拒絕了來自${msg.receiver}的合併請求`
      break
    case 'GIFT_REQUEST_MERGE_ALLOW_GIVER':
      text = `您接受了來自${msg.receiver}的合併請求`
      break
    case 'GIFT_REQUEST_MERGE_ALLOW_RECEIVED':
      text = `您的合併請求已被${msg.giver}接受`
      break
    case 'GIFT_REQUEST_MERGE_NOTICE_RECEIVED':
      text = `${msg.giver}合併了「${msg.name}」等禮物`
      break
    case 'GIFT_REQUEST_MERGE_REJECT_RECEIVED':
      text = `您的合併請求已被${msg.giver}拒绝`
      break
    case 'GIFT_REQUEST_MERGE_APPLY_RECEIVED':
      text = `您的合併請求已發出給${msg.giver}`
      break
    case 'NEED_DONATE_MERGE_NOTICE_GIVER':
      text = `您合併了送給${msg.receiver}的「${msg.name}」等物品`
      break
    case 'NEED_DONATE_MERGE_NOTICE_RECEIVED':
      text = `${msg.giver}合併了「${msg.name}」等物品`
      break
    case 'CARBON_LABELLING_ANNOUNCEMENT':
      if (msg.business) {
        const b = msg.business
        const body = b.content || b.text || b.body || ''
        const groupName = b.group_name || b.group_short_name || ''
        text = groupName ? `「${groupName}」團隊公告：\n${body}` : body
      }
      break
  }
  return text
}

export const getConversationContent = (content, conversation, business, isMergeChild, mregeChildTitle) => {
  const item = conversation
  const giver = item && (
    (item.need_donate && (item.need_donate.user_id === item.user.id ? item.user : item.direct_user)) ||
    (item.gift_request && (item.gift_request.user_id === item.direct_user_id ? item.user : item.direct_user)) || {})
  const receiver = item && (
    (item.need_donate && (item.need_donate.user_id === item.user.id ? item.direct_user : item.user)) ||
    (item.gift_request && (item.gift_request.user_id === item.direct_user_id ? item.direct_user : item.user)) ||
    (item.wish_donate && item.wish_donate.wish))
  let name = (item && (
    (item.gift_request && item.gift_request.gift && item.gift_request.gift.title) ||
    (item.need_donate && item.need_donate.need_item && item.need_donate.need_item.name) ||
    (item.wish_donate && item.wish_donate.wish && item.wish_donate.wish.title) ||
    (item.love_order_item && item.love_order_item && item.love_order_item.goods_name))) || ''
  const isMeet = item && (
    (item.gift_request && item.gift_request.shipway === 'meet') ||
    (item.need_donate && item.need_donate.shipway === 'meet'))
  const directPurchase = item && (
    (item.need_donate && item.need_donate.purchase_from === PURCHASE_FROM.DIRECT_PURCHASE)
  )
  let allNeedItemNames = ''
  let passNeedItemNames = ''
  if (item && item.gift_request && item.gift_request.children && item.gift_request.children.length) {
    name = item.gift_request.children.map(child => child.gift ? child.gift.title : '')
  } else if (item && item.need_donate && item.need_donate.children && item.need_donate.children.length) {
    name = []
    passNeedItemNames = []
    allNeedItemNames = []
    for (let child of item.need_donate.children) {
      if (child.status !== 'pass') {
        name.push(child.need_item.name)
      } else {
        passNeedItemNames.push(child.need_item.name)
      }
      allNeedItemNames.push(child.need_item.name)
    }
  }
  if (isMergeChild) {
    name = mregeChildTitle
  }
  let bundle = {
    text: content,
    name,
    isMeet,
    receiver: receiver && (receiver.nickname || receiver.student_name),
    giver: giver && giver.nickname,
    user_category: (item && item.user && item.user.cat_hash) || '',
    deal: (item && item.gift_request) || (item && item.need_donate) || (item && item.wish_donate) || (item && item.love_order_item),
    allNeedItemNames,
    passNeedItemNames,
    directPurchase
  }
  if (business) {
    bundle = {
      ...bundle,
      business: JSON.parse(business)
    }
  }
  const text = MapMsg(bundle)
  return (text || content)
}

// 判断打开小地球后点击消息列表应该做出的操作
// 1. 打开互动卡 default
// 2. 跳转到对应 礼物页面
// 2.1 礼物页面评论
// 3. 跳转到对应 需求页面
// 3.1 需求页面评论
// 4. 赠送者： 打开一个新的【一般礼物的弹窗】 需求者： 互动卡
export const mapBusinessId = (msg, userHash) => {
  let value = ''
  const { conversation, user_id: userId, business_id: businessId, content, business_type: businessType } = msg
  const business = (typeof businessId === 'string' ? JSON.parse(businessId) : businessId)
  if (business) {
    const {
      need_id: needId,
      gift_id: giftId,
      wish_id: wishId,
      story_id: storyId,
      bureau_id: bureauId,
      box_id: boxId,
      order_id: orderId,
      provision_id: provisionId,
      conversation_id: conversationId,
      url
    } = business
    let area = ''
    let areaId = ''
    switch (businessType) {
      case 'request_reason':
      case 'request_reason_reply':
        area = 'request'
        areaId = business.request_id || business.parent_request_id
        break
      case 'thanks':
      case 'thanks_reply':
        area = 'thank'
        areaId = business.thank_id || business.parent_thanks_id
        break
      case 'comment':
        area = 'comment'
        areaId = business.comment_id || business.parent_comment_id
        break
    }
    if (conversationId) {
      value = { path: `/chatroom/${conversationId}` }
    } else if (needId) {
      value = { path: `/need/${needId}${area ? `?area=${area}&area_id=${areaId}` : ''}` }
    } else if (wishId) {
      if (content === 'WISH_DONATE_GREETING_GIVER') {
        value = { path: `/wish/finish/${wishId}` }
      } else {
        value = { path: `/wish/${wishId}${area ? `?area=${area}&area_id=${areaId}` : ''}` }
      }
    } else if (storyId) {
      value = { path: `/story/${storyId}${area ? `?area=${area}&area_id=${areaId}` : ''}` }
    } else if (bureauId) {
      value = { path: `/city/taipei/give/${bureauId || 0}` }
    } else if (boxId || orderId) {
      value = { path: `/user/${userId}/shop` }
    } else if (giftId) {
      value = { path: `/gift/${giftId}${area ? `?area=${area}&area_id=${areaId}` : ''}` }
    } else if (url) {
      value = { url }
    } else if (provisionId) {
      value = { path: `/lovebox/${provisionId}${area ? `?area=${area}&area_id=${areaId}` : ''}` }
    } else if (business.carbon_labelling_id || business.group_id) {
      const gid = business.carbon_labelling_id || business.group_id
      value = { path: `/carbonlabelling/${gid}/announcements` }
    }
  } else {
    switch (msg.content) {
      case 'GIFT_REQUEST_THANKS_GIVER':
        value = { path: `/gift/${conversation.gift_request && conversation.gift_request.gift_id}?area=thank` }
        break
      case 'LOVE_BOX_THANKS_GIVER':
        value = { path: `/lovebox/${conversation.love_order_item && conversation.love_order_item.provision_id}?area=thank` }
        break
      case 'NEED_DONATE_THANKS_GIVER':
        value = { path: `/need/${conversation.need_donate && conversation.need_donate.need_item.need_id}?area=thank` }
        break
      case 'NEED_DONATE_QUANTITY_FULL_GIVER': // 赠送者 xxx 募满
      case 'NEED_DONATE_PULL_OFF_GIVER':
        value = { modal: 'openChatRoomModal' }
        break
      case 'SYSTEM_CONTENT_USER_IDENTITY_PASS':
      case 'SYSTEM_CONTENT_USER_ROLE_PASS':
        // 实名验证通过
        value = { path: `/user/${userId}` }
        break
      case 'SYSTEM_CONTENT_USER_ROLE_REJECT':
      case 'SYSTEM_CONTENT_USER_ROLE_TIMEOUT':
        // 跳转到身份转换页面
        value = {path: `/user/${userId}/change`}
        break
      case 'SYSTEM_CONTENT_USER_IDENTITY_REJECT':
        value = {path: `reverifyName`}
        break
      case 'LOVE_BOX_RECEIVED':
        value = { path: `/user/${userId}/shop` }
        break
      case 'NEW_USER_INTERESTS':
        const { gift_id: giftId, need_id: needId, provision_id: provisionId } = JSON.parse(msg.business_id)
        if (giftId) {
          value = { path: `/gift/${giftId}` }
        } else if (needId) {
          value = { path: `/need/${needId}` }
        } else if (provisionId) {
          value = { path: `/lovebox/${provisionId}` }
        }
        break
      default:
        if (conversation) {
          value = { modal: 'openChatRoomModal' }
        }
        break
    }
  }
  return value
}

export const isEmail = (str) => {
  // eslint-disable-next-line
  const regExp = /^[A-Za-z0-9_\-\.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  return regExp.test(str)
}

export const getLastChar = (str, number = 5) => {
  const length = str.length
  if (length <= number) {
    return str
  }
  return str.substr(length - number)
}

export const isPhone = (phone) => {
  return phoneRegex.test(phone)
}

/**
 * 判斷是否為手機或者座機號碼
 * @param {String} phone
 * @returns { Boolean }
 */
export const isPhoneOrTelephone = (phone) => {
  return phoneRegex.test(phone) || telRegex.test(phone)
}

export const mapGeo = (geo) => {
  let obj = {}
  let arr = []
  geo.forEach(item => {
    // 每一个市变成obj，可以添加区
    obj[item.city] = {}
  })
  geo.forEach(item => {
    obj[item.city][item.district] = item.id
  })
  for (const [key1] of Object.entries(obj)) {
    arr.push({
      name: key1,
      value: key1,
      parent: 0
    })
    for (const [key2] of Object.entries(obj[key1])) {
      arr.push({
        name: key2,
        value: key2,
        parent: key1
      })
    }
  }
  return arr
}

export const statusMapStep = (status) => {
  if (!status) {
    return 0
  }

  let match = statusMap.find(item => (item.text === status))
  if (match) {
    return match.value
  }
  return 0
}

export const formatPalmBox = (originData) => {
  const obj = {}
  originData.forEach(item => {
    if (!(item.CITYNAME in obj)) {
      obj[item.CITYNAME] = {}
      obj[item.CITYNAME][item.DICTNAME] = []
      obj[item.CITYNAME][item.DICTNAME].push(item)
    } else if (!(item.DICTNAME in obj[item.CITYNAME])) {
      obj[item.CITYNAME][item.DICTNAME] = []
      obj[item.CITYNAME][item.DICTNAME].push(item)
    } else if (item.DICTNAME in obj[item.CITYNAME]) {
      obj[item.CITYNAME][item.DICTNAME].push(item)
    }
  })
  return obj
}
